<template>
    <div>
        <div class="flex justify-content-center align-items-center p--35">
            <ComingSoon />
        </div>
    </div>
</template>

<script>
import ComingSoon from "../ui/emptyPage/ComingSoon.vue";

export default {
    name: "ClientDocuments",

    components: { ComingSoon },
    
    data() {
        return {
            
        };
    },
    computed: {},
    methods: {},
};
</script>